import axios from "axios";
import { checkToken, sessionCookies } from "../utils/helpers";

function getHeaders() {
  return {
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: {
      Authorization: checkToken() && localStorage.getItem('token') || ''
    },
    timeout: 300000,
  }
}

export default () =>
axios.create(getHeaders());

